// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"b61a9076","71":"c6c9c57f","249":"73901469","791":"19731334"}[chunkId] + ".js";
};